import React from 'react';
import { Container, Title, Body } from './styles';

import CentralListOfCategories01 from '../../../../../components/CentralListOfCategories01';
import CentralListOfCategories02 from '../../../../../components/CentralListOfCategories02';
import CentralCard01 from '../../../../../components/CentralCard01';
import Microscope from '../../img/microscope.png';

import CentralCard02 from '../../../../../components/CentralCard03';
import Ensaio from '../../img/Ensaio.jpg';

export default function ContentCenter() {
  return (
    <Container>
      <Title>Todas as categorias</Title>
      <Body>
        <CentralListOfCategories01 title="Grupo 01">
          <CentralListOfCategories02 title="SubCategory 01">
            <CentralCard01 title="Item" imgSrc={Microscope} route="/" />
            <CentralCard01 title="Item" imgSrc={Microscope} route="/" />
            <CentralCard01 title="Item" imgSrc={Microscope} route="/" />
            <CentralCard01 title="Item" imgSrc={Microscope} route="/" />
            <CentralCard01 title="Item" imgSrc={Microscope} route="/" />
            <CentralCard01 title="Item" imgSrc={Microscope} route="/" />
          </CentralListOfCategories02>
          <CentralListOfCategories02 title="SubCategory 02">
            <CentralCard01 title="Item" imgSrc={Microscope} route="/" />
            <CentralCard01 title="Item" imgSrc={Microscope} route="/" />
            <CentralCard01 title="Item" imgSrc={Microscope} route="/" />
          </CentralListOfCategories02>
          <CentralListOfCategories02 title="SubCategory 02">
            <CentralCard01 title="Item" imgSrc={Microscope} route="/" />
            <CentralCard01 title="Item" imgSrc={Microscope} route="/" />
            <CentralCard01 title="Item" imgSrc={Microscope} route="/" />
            <CentralCard01 title="Item" imgSrc={Microscope} route="/" />
            <CentralCard01 title="Item" imgSrc={Microscope} route="/" />
          </CentralListOfCategories02>
        </CentralListOfCategories01>
        <CentralListOfCategories01 title="Grupo 02">
          <CentralListOfCategories02 title="SubCategory 01">
            <CentralCard01 title="Item" imgSrc={Microscope} route="/" />
            <CentralCard01 title="Item" imgSrc={Microscope} route="/" />
            <CentralCard01 title="Item" imgSrc={Microscope} route="/" />
            <CentralCard01 title="Item" imgSrc={Microscope} route="/" />
            <CentralCard01 title="Item" imgSrc={Microscope} route="/" />
          </CentralListOfCategories02>
          <CentralListOfCategories02 title="SubCategory 02">
            <CentralCard01 title="Item" imgSrc={Microscope} route="/" />
            <CentralCard01 title="Item" imgSrc={Microscope} route="/" />
            <CentralCard01 title="Item" imgSrc={Microscope} route="/" />
          </CentralListOfCategories02>
          <CentralListOfCategories02 title="SubCategory 02">
            <CentralCard01 title="Item" imgSrc={Microscope} route="/" />
            <CentralCard01 title="Item" imgSrc={Microscope} route="/" />
            <CentralCard01 title="Item" imgSrc={Microscope} route="/" />
            <CentralCard01 title="Item" imgSrc={Microscope} route="/" />
            <CentralCard01 title="Item" imgSrc={Microscope} route="/" />
          </CentralListOfCategories02>
        </CentralListOfCategories01>
        <CentralListOfCategories01 title="Grupo 03">
          <CentralCard02
            imgSrc={Ensaio}
            imgAlt="Ensaio"
            title="Ensaio de tração"
            text="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla
        egestas mi commodo, hendrerit urna ut, feugiat purus. Nulla volutpat, erat."
            contact="(48)999999999"
            route="/"
            buttonText="Solicite"
          />
          <CentralCard02
            imgSrc={Ensaio}
            imgAlt="Ensaio"
            title="Ensaio de tração"
            text="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla
        egestas mi commodo, hendrerit urna ut, feugiat purus. Nulla volutpat, erat."
            contact="(48)999999999"
            route="/"
            buttonText="Solicite"
          />
        </CentralListOfCategories01>
        <CentralListOfCategories01 title="Grupo 04">
          <CentralCard02
            imgSrc={Ensaio}
            imgAlt="Ensaio"
            title="Ensaio de tração"
            text="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla
        egestas mi commodo, hendrerit urna ut, feugiat purus. Nulla volutpat, erat."
            contact="(48)999999999"
            route="/"
            buttonText="Solicite"
          />
          <CentralCard02
            imgSrc={Ensaio}
            imgAlt="Ensaio"
            title="Ensaio de tração"
            text="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla
        egestas mi commodo, hendrerit urna ut, feugiat purus. Nulla volutpat, erat."
            contact="(48)999999999"
            route="/"
            buttonText="Solicite"
          />
        </CentralListOfCategories01>
      </Body>
    </Container>
  );
}
